import Enum from './Enum';

class PlanetFiscalNumberType extends Enum {
    Internal = {
        value: 'internal',
        label: 'Planet Sequential',
    };

    OrderId = {
        value: 'order_id',
        label: 'Shopify Order ID',
    };

    OrderName = {
        value: 'order_name',
        label: 'Shopify Order Name',
    };

    OrderConfirmation = {
        value: 'order_confirmation',
        label: 'Shopify Order Confirmation',
    };

    Receipt = {
        value: 'receipt',
        label: 'Receipt Number',
    };

    Empty = {
        value: 'empty',
        label: 'Empty',
    };

    Custom = {
        value: 'custom',
        label: 'Custom (Advanced)',
    };
}

export default new PlanetFiscalNumberType();
